import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";

function Clientcloud() {
  return (
    <section className="client_cloud p-100" style={{ background: "#F4F4F4" }}>
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={6} xxl={6}>
            <h2>What our Clients Say</h2>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="client_cloud_slider"
            >
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Damon Gregg</h5>
                    <p>
                      "Our experience with TekRevol's cloud migration services
                      was exceptional. Their team meticulously planned and
                      executed our migration, ensuring minimal disruptions and
                      cost savings. Our operations are now more streamlined and
                      scalable, thanks to their expertise."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Debbie Ulrich</h5>
                    <p>
                      "TekRevol's cloud migration experts guided us through
                      every step of the process. Their attention to detail and
                      commitment to delivering results exceeded our
                      expectations. We've seen a significant improvement in
                      performance and cost-efficiency post-migration."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Judith Aguirre</h5>
                    <p>
                      "We were impressed by TekRevol's knowledge and
                      professionalism during our cloud migration project. They
                      addressed our unique challenges and provided tailored
                      solutions that improved our infrastructure's resilience
                      and security. Highly recommended for businesses seeking
                      seamless cloud transitions."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Jeremy Rolling</h5>
                    <p>
                      "Working with TekRevol was a game-changer for our startup.
                      Their expertise in cloud migration helped us scale our
                      operations without compromising on performance or
                      security. The results have been transformative, allowing
                      us to focus on innovation and growth."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Scott L. Gilbreath</h5>
                    <p>
                      "TekRevol's cloud migration services have been
                      instrumental in optimizing our IT infrastructure. Their
                      proactive approach and ongoing support post-migration have
                      ensured a smooth transition and improved operational
                      efficiency. We're delighted with the outcomes and look
                      forward to continued collaboration."
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Damon Gregg</h5>
                    <p>
                      "Our experience with TekRevol's cloud migration services
                      was exceptional. Their team meticulously planned and
                      executed our migration, ensuring minimal disruptions and
                      cost savings. Our operations are now more streamlined and
                      scalable, thanks to their expertise."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Debbie Ulrich</h5>
                    <p>
                      "TekRevol's cloud migration experts guided us through
                      every step of the process. Their attention to detail and
                      commitment to delivering results exceeded our
                      expectations. We've seen a significant improvement in
                      performance and cost-efficiency post-migration."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Judith Aguirre</h5>
                    <p>
                      "We were impressed by TekRevol's knowledge and
                      professionalism during our cloud migration project. They
                      addressed our unique challenges and provided tailored
                      solutions that improved our infrastructure's resilience
                      and security. Highly recommended for businesses seeking
                      seamless cloud transitions."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Jeremy Rolling</h5>
                    <p>
                      "Working with TekRevol was a game-changer for our startup.
                      Their expertise in cloud migration helped us scale our
                      operations without compromising on performance or
                      security. The results have been transformative, allowing
                      us to focus on innovation and growth."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client_cloud_box">
                  <div className="client_cloud_content">
                    <h5>Scott L. Gilbreath</h5>
                    <p>
                      "TekRevol's cloud migration services have been
                      instrumental in optimizing our IT infrastructure. Their
                      proactive approach and ongoing support post-migration have
                      ensured a smooth transition and improved operational
                      efficiency. We're delighted with the outcomes and look
                      forward to continued collaboration."
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientcloud;
